import api from '@/api';
import { PageResult } from '@/core/request/PageResult';
import { API_BASE_URL } from '../..';
import {
  InvoiceItemCreateRequest,
  InvoiceItemUpdateRequest,
  InvoiceItemUpdateResponse,
  ListInvoiceItemQuery,
} from './InvoiceNoteItems.types';

const CONTROLLER_URL = `${API_BASE_URL}/invoices/items`;

export async function invoiceNoteItems(
  id: number,
): Promise<PageResult<ListInvoiceItemQuery>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/invoice/${id}`,
    {},
  )) as unknown;

  return result as PageResult<ListInvoiceItemQuery>;
}

export async function createInvoiceNoteItems(
  obj: InvoiceItemCreateRequest,
): Promise<InvoiceItemUpdateResponse> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as InvoiceItemUpdateResponse;
}

export async function deleteInvoiceNoteItems(id: number) {
  const result = await api.remove(`${CONTROLLER_URL}/${id}`, {}, null);

  return result;
}

export async function getInvoiceNoteItemsId(
  id?: number,
): Promise<InvoiceItemUpdateResponse> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;
  return result as InvoiceItemUpdateResponse;
}

export async function updateInvoiceNoteItemsId(
  obj: InvoiceItemUpdateRequest,
): Promise<InvoiceItemUpdateResponse> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;
  return result as InvoiceItemUpdateResponse;
}
